import { Link, useSearchParams } from 'react-router-dom';
import { PERMISSIONS, type Permission } from '@lms/shared-types';
import { usePermissions } from '@/hooks/usePermissions';
import { courseTabHref, type CourseHubTab } from '@/lib/course-admin-navigation';

interface CourseHubTabsProps {
  courseId: string;
  active: CourseHubTab;
  studentHub?: boolean;
}

const TABS: {
  key: CourseHubTab;
  label: string;
  visible: (has: (permission: Permission) => boolean) => boolean;
}[] = [
  {
    key: 'curso',
    label: 'Curso',
    visible: (has) => has(PERMISSIONS.CURSOS_VER) || has(PERMISSIONS.MIS_CURSOS_VER),
  },
  {
    key: 'edicion',
    label: 'Modo edición',
    visible: (has) => has(PERMISSIONS.CONSTRUCTOR_EDITAR),
  },
  {
    key: 'detalle',
    label: 'Detalles del curso',
    visible: (has) => has(PERMISSIONS.CURSOS_VER),
  },
  {
    key: 'calificaciones',
    label: 'Calificaciones',
    visible: (has) => has(PERMISSIONS.CALIFICACIONES_VER) || has(PERMISSIONS.MIS_CURSOS_VER),
  },
  {
    key: 'foro',
    label: 'Foro',
    visible: (has) => has(PERMISSIONS.CURSOS_VER) || has(PERMISSIONS.MIS_CURSOS_VER),
  },
  {
    key: 'sesion',
    label: 'Horas de sesión',
    visible: (has) => has(PERMISSIONS.CURSOS_VER) || has(PERMISSIONS.PROGRESO_ADMINISTRAR),
  },
  {
    key: 'configuracion',
    label: 'Configuración',
    visible: (has) => has(PERMISSIONS.CURSOS_EDITAR) || has(PERMISSIONS.CURSOS_SUPERVISAR),
  },
];

export function CourseHubTabs({ courseId, active, studentHub = false }: CourseHubTabsProps) {
  const [searchParams] = useSearchParams();
  const { hasPermission } = usePermissions();
  const visible = TABS.filter((tab) => tab.visible(hasPermission));
  const useStudentRoutes = studentHub || (!hasPermission(PERMISSIONS.CURSOS_VER) && hasPermission(PERMISSIONS.MIS_CURSOS_VER));

  return (
    <nav className="lms-course-hub-tabs" aria-label="Navegación del curso">
      <div className="lms-course-hub-tabs__nav hide-scrollbar">
        {visible.map((tab) => (
          <Link
            key={tab.key}
            to={courseTabHref(courseId, tab.key, searchParams, { studentHub: useStudentRoutes })}
            className={`lms-course-hub-tabs__link${active === tab.key ? ' lms-course-hub-tabs__link--active' : ''}`}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
